//src/styles/typography/sizes.js
/**
 * Font size configuration
 */

export const fontSize = {
  xs: "0.75rem",      // 12px
  sm: "0.875rem",     // 14px
  base: "1rem",       // 16px
  lg: "1.125rem",     // 18px
  xl: "1.25rem",      // 20px
  "2xl": "1.5rem",    // 24px
  "3xl": "1.75rem",   // 28px
  "4xl": "2rem",      // 32px
  "5xl": "2.5rem",    // 40px
  "6xl": "3rem",      // 48px
  "7xl": "3.5rem",    // 56px
  "8xl": "4rem",      // 64px
  "9xl": "4.5rem",    // 72px
};

export const responsiveFontSizes = {
  xs: {
    h1: fontSize["4xl"],
    h2: fontSize["3xl"],
    h3: fontSize["2xl"],
    h4: fontSize.xl,
    h5: fontSize.lg,
    h6: fontSize.base,
    body: fontSize.sm,
  },
  sm: {
    h1: fontSize["5xl"],
    h2: fontSize["4xl"],
    h3: fontSize["3xl"],
    h4: fontSize["2xl"],
    h5: fontSize.xl,
    h6: fontSize.lg,
    body: fontSize.base,
  },
  md: {
    h1: fontSize["6xl"],
    h2: fontSize["5xl"],
    h3: fontSize["4xl"],
    h4: fontSize["3xl"],
    h5: fontSize["2xl"],
    h6: fontSize.xl,
    body: fontSize.base,
  },
  lg: {
    h1: fontSize["7xl"],
    h2: fontSize["6xl"],
    h3: fontSize["5xl"],
    h4: fontSize["4xl"],
    h5: fontSize["3xl"],
    h6: fontSize["2xl"],
    body: fontSize.lg,
  },
};

export const getFontSize = (key, fallback = fontSize.base) => {
  return fontSize[key] || fallback;
};

export const remToPx = (rem) => {
  const basePx = 16;
  const numericValue = parseFloat(rem);
  return isNaN(numericValue) ? basePx : numericValue * basePx;
};

export const pxToRem = (px) => {
  const basePx = 16;
  return `${px / basePx}rem`;
};

export const getResponsiveFontSize = (variant, breakpoint = 'md') => {
  return responsiveFontSizes[breakpoint]?.[variant] || fontSize.base;
};

// No default export